import type { DocPageContent } from '../docs-content'

const page = {
  order: 18,
  slug: 'export',
  title: '导出',
  description: '使用格式、编码器、范围和预检在本地渲染视频或音频。',
  category: '输出',
  sections: [
    {
      title: '导出设置',
      items: [
        '选择"导出视频"进行视频渲染。',
        '选择"导出音频"进行纯音频输出。',
        '渲染整个项目或当前的入/出范围。',
        '根据审阅、分享或最终交付需求选择分辨率和质量。',
      ],
    },
    {
      title: '格式与编码器',
      items: [
        '视频容器格式包括 MP4、MOV、WebM 和 MKV。',
        '音频格式包括 MP3、AAC 和 WAV。',
        '编码器的可用性取决于当前浏览器。',
        '当所选编码器不可用时，剪见 JIAN 可以发出警告或使用备用方案。',
      ],
    },
    {
      title: '预检与进度',
      items: [
        '在导出前修复缺失的媒体。',
        '查看空范围、编码器、Worker 回退、大文件和导出时间过长等警告。',
        '保持标签页打开直到导出完成。',
        '导出完成后下载完成的文件。',
      ],
    },
  ],
} satisfies DocPageContent

export default page
